export class VettedStatementRelationshipTransformer {
  static transform(obj) {
    let vettedStatementRelationship = {};
    vettedStatementRelationship.id = obj.id;
    return vettedStatementRelationship;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/vettedStatementRelationships/vettedStatementRelationship.transformer.js